import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

import colors from '@/assets/scss/_themes-vars.module.scss'

import PageContainer from '@/components/ui/containers/PageContainer'

import EmergencyRoom from './components/EmergencyRoom'
import { useGetEmergencyRoomsQuery } from '@/core/services/room'

export function EmergenciesPage() {
  const { t } = useTranslation()

  const { data } = useGetEmergencyRoomsQuery()

  const emergencyRooms = useMemo(
    () =>
      data?.map((emergencyRoom) => ({
        id: emergencyRoom._id,
        name:
          !!emergencyRoom.creator && typeof emergencyRoom.creator !== 'string'
            ? `${emergencyRoom.creator.userInfo.name} ${emergencyRoom.creator.userInfo.surname}`
            : '',
        status: emergencyRoom.status,
      })) ?? [],
    [data]
  )

  return (
    <PageContainer>
      <Paper>
        <Stack>
          <List component="div" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <ListItem sx={{ width: 'auto' }}>
              <ListItemText
                primary={t('page.emergencies.title')}
                secondary={t('page.emergencies.subtitle')}
                sx={{
                  '& .MuiListItemText-primary': {
                    color: colors.gray900,
                    fontSize: '18px',
                    fontWeight: 'bold',
                  },
                  '& .MuiListItemText-secondary': {
                    color: colors.indigo700,
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />
            </ListItem>
          </List>
        </Stack>
        <Divider />
        <Grid container sx={{ p: '40px' }} spacing={3}>
          {emergencyRooms.map((room) => (
            <Grid key={room.id} item xs={6} sm={4} lg={3}>
              <EmergencyRoom id={room.id} name={room.name} status={room.status || ''} />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </PageContainer>
  )
}

export default EmergenciesPage
